export const UI_CONSTANTS = {
  BUTTON_SIZE: "h-8 w-8",
  DROPDOWN_WIDTH: "w-80",
  ICON_SIZE_SM: "size-3",
  ICON_SIZE: "size-4",
  DEFAULT_ACCEPT_TYPES: "image/*,application/pdf,.txt,.doc,.docx",
  MAX_LINES_MOBILE: "max-h-[7em] [@supports(height:1lh)]:max-h-[5lh]",
  MAX_LINES_DESKTOP: "@md:max-h-[13em] @md:[@supports(height:1lh)]:max-h-[9lh]",
} as const;

export const ARIA_LABELS = {
  ATTACH_FILES: "Attach files",
  REMOVE_FILE: "Remove attached file",
  STOP_EXECUTION: "Stop execution",
  SEND_MESSAGE: "Send message",
  MODE_SELECTOR: "Select chat mode",
} as const;
